<template>
    <div class="order-item-container bg-light min-vh-100">
        <!-- Welcome Header -->
        <!-- Welcome Header -->
        <div class="card border-0 shadow-sm rounded-4 mb-4 overflow-hidden">
            <div class="card-body p-3" style="background: linear-gradient(135deg, #e0f2fe 0%, #f0f9ff 100%);">
                <div class="position-relative z-1 d-flex align-items-center justify-content-between gap-2">
                    <div style="flex: 1; min-width: 0;">
                         <div class="d-flex align-items-center gap-2 mb-1">
                             <h6 class="mb-0 text-muted">Welcome back!</h6>
                             <span class="fs-4">👋</span>
                         </div>
                         <h2 class="fw-bold mb-1 text-primary text-truncate">{{ user?.name || 'Handyman' }}</h2>
                         <div class="d-flex align-items-center gap-2 small text-secondary">
                             <i class="bi bi-calendar4-week"></i>
                             <span>{{ getCurrentDate() }}</span>
                         </div>
                    </div>
                    <div class="flex-shrink-0">
                        <div class="bg-white px-2 py-1 rounded-4 shadow-sm border border-light">
                            <div class="text-primary fw-bold fs-5 mb-0 text-nowrap" style="font-variant-numeric: tabular-nums;">
                                {{ currentTime }}
                            </div>
                        </div>
                    </div>
                </div>
                 <!-- Decorative elements (subtle) -->
                 <div class="position-absolute" style="width: 150px; height: 150px; background: rgba(13, 110, 253, 0.05); border-radius: 50%; top: -50px; right: -50px;"></div>
                 <div class="position-absolute" style="width: 100px; height: 100px; background: rgba(13, 110, 253, 0.05); border-radius: 50%; bottom: -30px; left: 20%;"></div>
            </div>
        </div>

        <!-- Summary Cards -->
        <!-- Summary Cards -->
        <!-- Summary Cards Strip -->
        <div class="card border-0 shadow-sm rounded-4 mb-4" style="background: linear-gradient(90deg, #E3F2FD 0%, #F3E5F5 100%);">
            <div class="card-body p-0">
                <div class="row g-0 text-center">
                    <div class="col-3 py-3 px-1 border-end">
                        <div class="d-flex align-items-center justify-content-center gap-2 mb-1">
                            <i class="bi bi-clipboard-check-fill fs-3 text-primary"></i>
                            <h2 class="fw-bold text-dark mb-0 fs-4">{{ todayOrders.length }}</h2>
                        </div>
                        <h6 class="text-muted small mb-0">Today's<br/>{{ todayOrders.length == 1 ? 'Job' : 'Jobs' }}</h6>
                    </div>
                    <div class="col-3 py-3 px-1 border-end">
                        <div class="d-flex align-items-center justify-content-center gap-2 mb-1">
                            <i class="bi bi-check-circle-fill fs-3 text-success"></i>
                            <h2 class="fw-bold text-dark mb-0 fs-4">{{ completedTodayCount }}</h2>
                        </div>
                        <h6 class="text-muted small mb-0">{{ completedTodayCount == 1 ? 'Job' : 'Jobs' }}<br/>Completed</h6>
                    </div>
                    <div class="col-3 py-3 px-1 border-end">
                         <div class="d-flex align-items-center justify-content-center gap-2 mb-1">
                            <i class="bi bi-hourglass-split fs-3 text-warning"></i>
                            <h2 class="fw-bold text-dark mb-0 fs-4">{{ overdueTasks.length }}</h2>
                        </div>
                        <h6 class="text-muted small mb-0">Pending<br/>{{ overdueTasks.length == 1 ? 'Job' : 'Jobs' }}</h6>
                    </div>
                    <div class="col-3 py-3 px-1">
                         <div class="d-flex align-items-center justify-content-center gap-2 mb-1">
                            <i class="bi bi-briefcase-fill fs-3" style="color: #6f42c1;"></i>
                            <h2 class="fw-bold text-dark mb-0 fs-4">{{ futureOrders.length }}</h2>
                        </div>
                        <h6 class="text-muted small mb-0">New<br/>Assigned</h6>
                    </div>
                </div>
            </div>
        </div>

        <!-- Section Header -->
        <div class="d-flex align-items-center mb-3">
            <div class="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center me-2" style="width: 32px; height: 32px;">
                <i class="bi bi-clipboard-check"></i>
            </div>
            <h5 class="fw-bold mb-0 text-dark">Work List</h5>
            <div class="ms-auto text-muted small">
                {{ overdueTasks.length + todayOrders.length }} Tasks to Complete
            </div>
        </div>

        <div class="order-list-group">
            <div class="card border-0 shadow-sm rounded-4">
                <div class="card-body p-2">
                    <!-- Bordered Tabs -->
                    <ul class="nav nav-pills nav-fill mb-3 p-1 bg-light rounded-3 flex-nowrap overflow-auto" role="tablist">
                        <li 
                            v-if="overdueTasks.length > 0"
                            class="nav-item" 
                            role="presentation"
                        >
                            <button
                                class="nav-link rounded-3 py-2 px-1 small fw-bold"
                                data-bs-toggle="tab"
                                data-bs-target="#overdue-orders"
                                aria-selected="false"
                                role="tab"
                                tabindex="-1"
                                :class="{ active: activeTab == 'overdue', 'bg-white shadow-sm text-danger': activeTab == 'overdue', 'text-muted': activeTab != 'overdue' }"
                                @click="activeTab = 'overdue'"
                            >Overdue</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button
                                class="nav-link rounded-3 py-2 px-1 small fw-bold"
                                data-bs-toggle="tab"
                                data-bs-target="#today-orders"
                                aria-selected="false"
                                role="tab"
                                tabindex="-1"
                                :class="{ active: activeTab == 'today', 'bg-white shadow-sm text-primary': activeTab == 'today', 'text-muted': activeTab != 'today' }"
                                @click="activeTab = 'today'"
                            >Today</button>
                        </li>

                        <li class="nav-item" role="presentation">
                            <button
                                class="nav-link rounded-3 py-2 px-1 small fw-bold"
                                data-bs-toggle="tab"
                                data-bs-target="#tomorrow-orders"
                                aria-selected="true"
                                role="tab"
                                :class="{ active: activeTab == 'tomorrow', 'bg-white shadow-sm text-primary': activeTab == 'tomorrow', 'text-muted': activeTab != 'tomorrow' }"
                                @click="activeTab = 'tomorrow'"
                            >Tomorrow</button>
                        </li>

                        <li class="nav-item" role="presentation">
                            <button
                                class="nav-link rounded-3 py-2 px-1 small fw-bold"
                                data-bs-toggle="tab"
                                data-bs-target="#future-orders"
                                aria-selected="false"
                                role="tab"
                                tabindex="-1"
                                :class="{ active: activeTab == 'future', 'bg-white shadow-sm text-primary': activeTab == 'future', 'text-muted': activeTab != 'future' }"
                                @click="activeTab = 'future'"
                            >Future</button>
                        </li>

                    </ul>
                    <div class="tab-content pt-2">
                        <div 
                            v-if="overdueTasks.length > 0"
                            class="tab-pane fade" 
                            id="overdue-orders" 
                            role="tabpanel" 
                            :class="{ 'active show': activeTab == 'overdue' }"
                        >
                            <OrderCard 
                                key="overdue"
                                :orders="overdueTasks" 
                                :projects="[]" 
                                tab="overdue"
                            />
                        </div>
                        <div class="tab-pane fade" id="today-orders" role="tabpanel" :class="{ 'active show': activeTab == 'today' }">
                            <OrderCard :orders="todayOrders" :projects="todayProjects" key="today"/>
                        </div>
                        <div class="tab-pane fade" id="tomorrow-orders" role="tabpanel" :class="{ 'active show': activeTab == 'tomorrow' }">
                            <OrderCard :orders="tomorrowOrders" :projects="tomorrowProjects" key="tomorrow"/>
                        </div>
                        <div class="tab-pane fade" id="future-orders" role="tabpanel" :class="{ 'active show': activeTab == 'future' }">
                            <OrderCard :orders="futureOrders" :projects="futureProjects" key="future"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { appMixin } from "../mixin/appMixin";
import OrderCard from "./OrderCard";

export default {
    name: 'HandymanOrder',
    mixins: [appMixin],
    components: {
        OrderCard
    },
    data() {
        return {
            orders: [],
            activeTab: 'today',
            todayOrders: [],
            tomorrowOrders: [],
            futureOrders: [],
            projects: [],
            todayProjects: [],
            tomorrowProjects: [],
            futureProjects: [],
            overdueTasks: [],
            completedTodayCount: 0,
            currentTime: '',
            timer: null
        }
    },
    created() {

    },
    mounted() {
        this.getOrders();
        this.getProjects();
        this.getOverdueTasks();
        this.updateTime();
        this.timer = setInterval(this.updateTime, 1000);
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        }
    },
    methods: {
        getOrders() {
            axios.post('/handyman/get-orders')
                .then(response => {
                    this.orders = response.data.orders;
                    this.completedTodayCount = response.data.completed_today_count || 0;

                    this.categorizeOrders();
                });
        },
        /* viewOrder(order) {
            window.location.href = "/handyman/orders/" + order.order_number.toLowerCase();
        },
        getGoogleMapsUrl(address) {
            // Encode the address using encodeURIComponent
            //return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
            // open in new tab
            window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
        }, */
        // Helper to format a Date object into YYYY-MM-DD string format
        getCurrentDate() {
            // Returns current date in format: Saturday, 04 Jan 2026
            return this.moment().format('dddd, DD MMM YYYY');
        },
        updateTime() {
            this.currentTime = this.moment().format('hh:mm:ss A');
        },
        // Helper to add days to a given date
        addDays(date, days) {
            const result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        },
        // Method to categorize orders into today, tomorrow, and future
        categorizeOrders() {
            const today = this.moment().startOf('day');
            const tomorrow = this.moment().add(1, 'days').startOf('day');

            this.orders.forEach(order => {
                const bookingDate = this.moment(order.booking_date);

                if (bookingDate.isSame(today, 'day')) {
                    this.todayOrders.push(order);
                } else if (bookingDate.isSame(tomorrow, 'day')) {
                    this.tomorrowOrders.push(order);
                } else if (bookingDate.isAfter(tomorrow, 'day')) {
                    this.futureOrders.push(order);
                }
            });
            /* const today = this.getDateString(new Date());
            const tomorrow = this.getDateString(this.addDays(new Date(), 1));

            this.todayOrders = [];
            this.tomorrowOrders = [];
            this.futureOrders = [];

            this.orders.forEach(order => {
                const bookingDate = order.booking_date.split(' ')[0]; // Extract just the date part
                if (bookingDate === today) {
                    console.log("today");
                    this.todayOrders.push(order);
                } else if (bookingDate === tomorrow) {
                    console.log("tomorrow");
                    this.tomorrowOrders.push(order);
                } else if (bookingDate > tomorrow) {
                    console.log("future");
                    this.futureOrders.push(order);
                }
            });*/
        },
        getProjects() {
            axios.post('/api/projects')
                .then(response => {
                    this.projects = response.data.projects;
                    this.categorizeProjects();
                });
        },
        categorizeProjects() {
            const today = this.moment().startOf('day');
            const tomorrow = this.moment().add(1, 'days').startOf('day');
            const futureUserIds = new Set();

            this.projects.forEach(project => {
                const todayUsers = project.users.filter(user => this.moment(user.work_date).isSame(today, 'day') && user.user_id === this.user.id);
                const tomorrowUsers = project.users.filter(user => this.moment(user.work_date).isSame(tomorrow, 'day') && user.user_id === this.user.id);
                const futureUsers = project.users.filter(user => this.moment(user.work_date).isAfter(tomorrow, 'day') && user.user_id === this.user.id);

                if (todayUsers.length) {
                    this.todayProjects.push({ ...project, users: todayUsers });
                }
                if (tomorrowUsers.length) {
                    this.tomorrowProjects.push({ ...project, users: tomorrowUsers });
                }

                // Prepare future projects
                if (futureUsers.length) {
                    const uniqueUsersFuture = futureUsers.filter(user => {
                        if (futureUserIds.has(user.user_id)) {
                            return false;
                        } else {
                            futureUserIds.add(user.user_id);
                            return true;
                        }
                    });
                    if (uniqueUsersFuture.length) {
                        this.futureProjects.push({ ...project, users: uniqueUsersFuture });
                    }
                }
            });
        },
        getOverdueTasks() {
            axios.post('/api/handyman/overdue-tasks')
                .then(response => {
                    this.overdueTasks = response.data.orders;
                });
        },
        getCurrentDate() {
            // Returns current date in format: Saturday, 04 Jan 2026
            return this.moment().format('dddd, DD MMM YYYY');
        }
    }
}
</script>
